export const openWhatsApp = () => {
  const auditMessage = `Hi, I want to get a Free Inventory Audit for my store.

  Store Type:
  City:
  Do you use POS/Excel:

  Looking forward to knowing how Stock Move can help.`;
  const phoneNumber = "918146987589"; 

  const encodedMessage = encodeURIComponent(auditMessage);

  const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  window.open(url, "_blank");
};